import React, { useMemo, useCallback } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { makeViewHide, getCoverSize } from '~data/selectors/bookmarks'
import { changeCoverSize } from '~data/actions/bookmarks'

import { Label, Range } from '~ui'

export default function BookmarksHeaderViewCoverSize({
    spaceId = 0,
    collection = {}
}) {
    const dispatch = useDispatch()
    const { view } = collection
    const getViewHide = useMemo(() => makeViewHide(), [])

    const viewHide = useSelector(state => getViewHide(state, spaceId))
    const coverSize = useSelector(state => getCoverSize(state, view))

    const onCoverSizeChange = useCallback(
        e => {
            dispatch(changeCoverSize(spaceId, view, parseInt(e.target.value)))
        },
        [dispatch, spaceId, view]
    )

    switch (view) {
        case 'grid':
        case 'masonry':
            if (viewHide.includes('cover')) return null
            break

        default:
            return null
    }

    return (
        <>
            <Label>{t.s('cover')}</Label>

            <div>
                <Range
                    min='1'
                    max='10'
                    value={coverSize}
                    onChange={onCoverSizeChange} />
            </div>
        </>
    )
}
